import React from "react";
import jwtDecode from "jwt-decode";

import { ROLE_ADMIN } from "constants/role";

import { useApp } from "context/appContext";

import Login from "./layout";

function LoginContainer({ history }) {
  const { login, loading, showNotification } = useApp();
  const handleLogin = async (values) => {
    try {
      const user = await login(values);
      if (user) {
        localStorage.setItem("utk", user.token);
        const tokenDecode = jwtDecode(user.token);
        if (tokenDecode.roles.includes(ROLE_ADMIN)) {
          history.push("/inicio");
        } else {
          history.push("/registro");
        }
      } else {
        showNotification("Ha ocurrido un error al intentar iniciar sesión, revise los datos.", "error")
      }
    } catch (error) {
      console.log(error)
      showNotification("Ha ocurrido un error al intentar iniciar sesión, revise los datos.", "error")
    }
  };

  return <Login onSubmit={handleLogin} loading={loading} />;
}

export default LoginContainer;
